import { mapGetters } from 'vuex';
export default {
  name: 'Footer',
  computed: {
    ...mapGetters(['userConfig']),
    footerLink() {
      return this.userConfig?.footerLink || 'https://github.com/MarSeventh';
    },
    thisYear() {
      return new Date().getFullYear();
    },
    disableFooter() {
      return this.userConfig?.disableFooter || false;
    }
  }
};